import React from "react";
import { Button } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { Form, Formik, ErrorMessage } from "formik";
import { EditProfileSchema } from "../../../../../helpers/schemas";
import { updateUser as updateUserApi } from "../../../../../api/clients/users";
import { Prompt } from "react-router";
import { Messages } from "../../../../layout/Messages/Messages";
import { ClientFields } from "./ClientFields";
import {
  NOTIFICATION_CLIENT_ACTIONS,
} from '../../../../../config/notifications';
import { scrollToErrors } from '../../../../../helpers/general';

function ClientEditForm(props) {
  const { user, toggleEditMode, updateUser } = props;

  const submitForm = (values) => {
    const payload = {
      data: {
        id: user.id,
        first_name: values.firstName,
        last_name: values.lastName,
        email: values.email,
      },
      notificationId: NOTIFICATION_CLIENT_ACTIONS
    };

    updateUserApi( payload ).then( (response) => {
      if (response && response.data && response.data.id) {
        toggleEditMode( "user", false );
        updateUser( response.data );
      }
    } );
  };

  return (
    <section className="user-detail-section" aria-labelledby="user-details-edit-heading">
      <div className="user-detail-section__header">
        <h2 className="user-detail-section__title" id="user-details-edit-heading">
          <FormattedMessage id="fields.user_details"/>
        </h2>
      </div>
      <Formik
          key="add_user"
          initialValues={{
            firstName: user.first_name || "",
            lastName: user.last_name || "",
            email: user.email || "",
          }}
          validationSchema={EditProfileSchema}
          validateOnChange={false}
          onSubmit={submitForm}
        >
          {(props) => {
            scrollToErrors(props)
            return (
              <Form>
                <div className="mx-2">
                  <Messages color="danger" formikProps={props}>
                    <ErrorMessage
                      name="firstName"
                      component="div"
                      data-testid="errors-firstName"
                      className="field-error"
                    />
                    <ErrorMessage
                      name="lastName"
                      component="div"
                      data-testid="errors-lastName"
                      className="field-error"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      data-testid="errors-email"
                      className="field-error"
                    />
                  </Messages>
                </div>

                <Prompt
                  when={props.initialValues !== props.values}
                  message={(location) =>
                    `You have unsaved changes, are you sure you want to leave the form?`
                  }
                />

                <ClientFields formikProps={props} user={user}/>

                <div className="text-right py-3">
                  <Button name="save" type="submit" color="primary">
                    <FormattedMessage id="button.save"/>
                  </Button>
                  <Button
                    color="secondary"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleEditMode( "user", false );
                    }}
                  >
                    <FormattedMessage id="button.cancel"/>
                  </Button>
                </div>
              </Form>
            );
          }}
      </Formik>
    </section>
  );
}

export { ClientEditForm };
